import { render } from "./userLang.vue?vue&type=template&id=4dc499dd"
import script from "./userLang.vue?vue&type=script&lang=js"
export * from "./userLang.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__